import { useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export const ShortThumb = ({ video: v, to }) => {
  const [broken, setBroken] = useState(false);
  return (
  <Link
    to={to}
    data-testid={`short-thumb-${v.id}`}
    className="group/short block w-[150px] md:w-[190px] shrink-0"
  >
    <div className="relative aspect-[9/16] overflow-hidden bg-[#0A0A0F] border border-white/10 rounded-md">
      {!broken && (v.thumbnail_url || v.youtube_id) ? (
        <img
          src={v.thumbnail_url || `https://i.ytimg.com/vi/${v.youtube_id}/hqdefault.jpg`}
          alt={v.title}
          loading="lazy"
          draggable={false}
          onContextMenu={(e) => e.preventDefault()}
          onError={() => setBroken(true)}
          className="w-full h-full object-cover opacity-90 group-hover/short:opacity-100 group-hover/short:scale-105 transition-all duration-300 select-none"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460]" />
      )}
      <div className="absolute top-2 left-2 text-[10px] font-bold uppercase tracking-wide bg-black/70 text-white px-1.5 py-0.5 rounded-sm">
        {v.source === "tiktok" ? "TikTok" : v.source === "instagram" ? "Reel" : "Short"}
      </div>
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover/short:opacity-100 transition-opacity">
        <div className="w-11 h-11 bg-white/90 rounded-full flex items-center justify-center">
          <Play className="w-4 h-4 text-black fill-black ml-0.5" />
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/90 to-transparent">
        <p className="text-xs text-white line-clamp-2 leading-tight">{v.title}</p>
      </div>
    </div>
  </Link>
);
};
